import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=d5799a9c&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=d5799a9c&prod&lang=css"
import style1 from "./userCenter.vue?vue&type=style&index=1&id=d5799a9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5799a9c",
  null
  
)

export default component.exports